import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
var Notification = {
  pn: 'div[data-name=notification]',
  page: 0,
  limit: 20,
  currentDisplay: 0,
  allowInfinite: true,
  hasMoreItems: true,
  totalItems: 0,
  init: function init() {
    var self = this;
    self.page = 0;
    self.currentDisplay = 0;
    self.allowInfinite = true;
    self.hasMoreItems = true;
    self.list();
    $(self.pn + ' .infinite-scroll-content').on('infinite', function () {
      if (!self.allowInfinite) return;
      self.allowInfinite = false;
      self.page += 1;
      self.list();
    });
  },
  list: function () {
    var _list = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var self, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = this;
              _context.next = 3;
              return Base.api('Notification', 'list', {
                page: this.page,
                limit: this.limit
              });

            case 3:
              rs = _context.sent;
              self.totalItems = rs.total;

              if (!(rs.rows.length == 0)) {
                _context.next = 8;
                break;
              }

              $(self.pn + ' .infinite-scroll-preloader').addClass('display-none');
              return _context.abrupt("return");

            case 8:
              self.currentDisplay += rs.rows.length;
              self.allowInfinite = true;
              rs.rows.forEach(function (item, i) {
                $(self.pn + ' .notification-list').append(self.row(item));
              });
              if (self.currentDisplay == self.totalItems || self.currentDisplay > self.totalItems) $(self.pn + ' .infinite-scroll-preloader').addClass('display-none');else $(self.pn + ' .infinite-scroll-preloader').removeClass('display-none');

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function list() {
      return _list.apply(this, arguments);
    }

    return list;
  }(),
  row: function row(item) {
    var $row = $("\n      <li>\n        <a href=\"#\" class=\"item-link item-content\">\n          <div class=\"item-inner\">\n            <div class=\"item-title-row\">\n              <div class=\"item-title\"></div>\n              <div class=\"item-after\">".concat(moment(item.created_date).format(Base.dateTimeFormat), "</div>\n            </div>\n            <div class=\"item-subtitle\">").concat(item.subject, "</div>\n            <div class=\"item-text\">").concat(item.message, "</div>\n          </div>\n        </a>\n      </li>"));
    return $row;
  }
};
export default (function ($prop, ctx) {
  ctx.$on('pageInit', function () {
    Notification.init();
  });

  var profile = function profile() {
    Base.profile();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="notification">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"></div>
        <div class="title sliding">Thông báo</div>
        <div class="right"><a href="#" @click=${profile}><i class="f7-icons icon">person_circle</i></a></div>
      </div>
    </div>
    <div class="page-content infinite-scroll-content infinite-scroll-bottom">
      <div class="searchbar-backdrop"></div>
      <div class="list media-list no-margin">
        <ul class="notification-list">

        </ul>
        <div class="preloader infinite-scroll-preloader"></div>
      </div>
    </div>
  </div>
`
    }
    ;
});